import { Component, ViewChild, AfterViewInit, ElementRef, TemplateRef, ViewContainerRef } from '@angular/core';
import { BannerSlider } from '../../models/BannerSlider/BannerSlider-model';
import { BannerSliderService } from '../../services/BannerSlider/BannerSlider.service';
import { User } from '../../models/user/user-model';
import { Category } from '../../models/category/category.model';
import { Brand } from '../../models/Brand/brand-model';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { Router, ActivatedRoute, Params } from "@angular/router";
import { UserService } from '../../services/user/user.service';
import { BrandService } from '../../services/brand/brand.service';
import { HttpEventType } from '@angular/common/http';
import { Http, Response, Headers } from '@angular/http';
import { CategoryService } from '../../services/category/category.service';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ProfileService } from '../../services/profile/profile.service';

import { MediaLibraryService } from '../../services/mediaLibrary/media-library.service';
import { MediaLibrary } from '../../models/mediaLibrary/media-library-model';
import { RolePermissionService } from '../../services/role/role-permission.service';
import { CookieService } from 'ngx-cookie-service';
@Component({
  selector: 'app-create-BannerSlider',
  templateUrl: './create-BannerSlider.component.html',
  styleUrls: ['./create-BannerSlider.component.css']
})
/** create- component*/
export class CreateBannerSliderComponent {
  public bannerSlider = new BannerSlider();
  public users: User[];
  public deleteValue: any;
  public categories: Category[];
  public brands: Brand[];
  isDisable = true;
  i: number;
  bannerSliderID: number;
  files: any = [];

  count: number;
  public sortValue: any;
  urls = new Array<string>();
  public progress: number;
  public message: string;
  public ExistsImagePath: string;
  userId: number;
  //public bellIcon: any;
  //public notificationTypes: string[];
  //public startDateElement: any;
  //public endDateElement: any;
  /** create-notification ctor */
  modalRef: BsModalRef;
  config = {
    animated: true
  };
  public mediaList: MediaLibrary[];
  mediaImageShow: boolean;
  banner: boolean=false;
  public url: any;
  constructor(private http: Http, private readonly brandService: BrandService, private readonly userService: UserService,
    private readonly router: Router, private readonly categoryService: CategoryService,
    private readonly profileService: ProfileService,
    private readonly mediaServices: MediaLibraryService,
    private modalService: BsModalService,
    private cookieService: CookieService,
    private readonly bannerSliderService: BannerSliderService, public toastr: ToastsManager, vcr: ViewContainerRef, private readonly rolePermissionService: RolePermissionService) {
    this.rolePermissionService.GetRolePermissions("bannerslider").subscribe(
      data => {
        if (data != null) {

          var create = data.filter(function (element) {
            return (element.action == "create");
          });

          if (create.length > 0) {
            this.toastr.setRootViewContainerRef(vcr);
            this.Getvenders();
            this.Getbrands();
            this.Getcategories();
            this.bannerSlider.isActive = true;
            this.bannerSlider.brandID = 0;
            this.bannerSlider.venderID = 0;
            this.bannerSlider.type = "";
            this.bannerSlider.webMobile = "";
            this.bannerSlider.sliderFor = "";
            this.profileService.getProfile().subscribe(
              data => {
                if (data) {

                  this.userId = data.userID;
                }
                else {
                  this.userId = 0;
                }
              });
          }
          else {
            this.router.navigate(["/BannerSlider-list"]);
          }
        }
        else {
          this.router.navigate(["/BannerSlider-list"]);
        }
      }
    )

  }

  Getvenders() {

    this.userService.getUsers().subscribe(
      data => {
        this.users = data;
      }
    )
  }
  Getbrands() {

    this.brandService.getBrand().subscribe(
      data => {
        this.brands = data;
      }
    )
  }
  Getcategories() {

    this.categoryService.GetCategoryList().subscribe(
      data => {
        this.categories = data;
      }
    )
  }
  onSubmit() {
    this.isDisable = false;
    this.count = 0;
    for (this.i = 0; this.i < this.urls.length; this.i++) {

      this.sortValue = document.getElementById("sort-order-" + this.i) as HTMLElement;
      if (typeof this.bannerSlider.sort != 'undefined')
        this.bannerSlider.sort += ',' + this.sortValue.value.toString();
      else
        this.bannerSlider.sort = this.sortValue.value.toString();
      this.count++;
    }
    this.bannerSliderService.addBannerSlider(this.bannerSlider).subscribe(
      data => {
        if (data) {
          this.toastr.success('Banner/Slider has been Saved.', 'Success');
          this.bannerSliderID = data;
          this.upload();
          setTimeout(() => {
            this.router.navigate(["/BannerSlider-list"]);
          }, 2000);

        }
        else {
          this.toastr.error('Error occurred. Please try again', 'Success');
          // this.isSubmitted = false;
        }

      });
  }
  UploadImages(event) {
    //ngAfterViewInit();
    //this.urls = [];

    // ;
    //this.urls = [];
    let files = event;

    for (let i = 0; i < files.length; i++) {
      if (this.files != null && this.files.length >= 0)
        this.files.push(files[i]);
      else
        this.files = [files[i]];
    }

    //files.forEach(file => {
    //  if (this.files != null && this.files.length >= 0)
    //    this.files.push(file);
    //  else
    //    this.files = [file];
    //});

    if (files) {
      for (let file of files) {
        let reader = new FileReader();
        reader.onload = (e: any) => {
          this.urls.push(e.target.result);
        }
        reader.readAsDataURL(file);
      }
    }
    //this.deleteValue = document.getElementById("sort-order-delete-" + this.i) as HTMLElement;
    //(this.deleteValue).value = path.id;
  }
  ResetValue() {
    
    this.bannerSlider.brandID = 0;
    this.bannerSlider.categoryID = 0;
    if (this.bannerSlider.sliderFor =='Brand')
      this.banner = true;
    else
      this.banner = false;
  }

  upload() {
    
    if (typeof this.files == "undefined")
      return;
    const formData = new FormData();
    this.count = 0;
    for (let file of this.files) {
      if (typeof file.name == 'undefined') {
        formData.append(file, new File([""], "dummy"));
      }
      else {
        formData.append(file.name, file);
      }

      this.sortValue = document.getElementById("sort-order-" + this.count) as HTMLElement;
      formData.append("sort-order-" + this.count, this.sortValue.value.toString());

      this.url = document.getElementById("url-" + this.count) as HTMLElement;
      formData.append("url-" + this.count, this.url.value.toString());

      this.count++;
    }
    // add BannerSliderID
    formData.append("BannerSliderID", this.bannerSliderID.toString());
    //let headers: HttpHeaders = new HttpHeaders();
    //headers.append("Token", this.cookieService.get('Login'));
    
    //const uploadReq = new HttpRequest('POST', `api/BannerSlider/UploadFile?userId=` + this.userId +'&banner='+this.banner,formData, {
    //  reportProgress: true,
    //  headers: headers 
    //});

    this.http.post(`api/BannerSlider/UploadFile?userId=` + this.userId + '&banner=' + this.banner, formData, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    }).map((response: Response) => response.json()).subscribe(event => {

      if (event.type === HttpEventType.UploadProgress)
        this.progress = Math.round(100 * event.loaded / event.total);
      else if (event.type === HttpEventType.Response)
        this.message = event.body.toString();
      //this.toastr.success('BannerSlider Added Successfully ', 'Success');
      setTimeout(() => {
        this.router.navigate(["/BannerSlider-list"]);
      }, 2000);
      // this.router.navigate(["/product-list"]);

    });

    //this.http.request(uploadReq).subscribe(event => {
      
    //});
  }
  deleteBannerSlider(id) {

    var ans = confirm("Are you sure to delete selected image?");
    if (ans) {
      this.urls.splice(id, 1);
      this.files.splice(id, 1);
      //$scope.product.productImagesFileList.splice($index, 1);

    }
  }
  //onSubmit() {
  //  this.categryFields.forEach((element) => {
  //    this.fieldname = "input-" + element.fieldName;
  //    this.inputElement = document.getElementById(this.fieldname) as HTMLElement;
  //    element.value = this.inputElement.value;
  //  });
  //  this.product.Fields = this.categryFields;
  //  this.productService.AddProduct(this.product).subscribe(
  //    data => {
  //      this.productID = data;
  //      this.upload();
  //    });

  //}
  SlectImage(Image: MediaLibrary) {
    // this.fileToUpload = null;
    //this.fd = new FormData();
    this.mediaImageShow = true;
    //this.selectedBrandImage = "";
    // this.brandModel.brandLogoImage = "";
    this.urls.push(Image.folderName + Image.fileName);
    this.files.push(Image.fileName);
    //this.upload();
    this.mediaList.forEach(x => {
      x.activeDiv = false;
    });


    Image.activeDiv = !Image.activeDiv;
  }

  ShowImage() {
    this.mediaImageShow = false;
    //this.selectedBrandImage = "";
    this.modalRef.hide();
  }
  HidePopup() {
    // this.selectedBrandImage = "";
    //this.brandModel.brandLogoImage = "";
    this.modalRef.hide();
  }
  OpenMediaPopup(template: TemplateRef<any>, ImageFor: string) {
    this.mediaServices.getMediaLibraryFor(ImageFor).subscribe(
      data => {
        
        this.mediaList = data;
        if (this.mediaList.length > 0) {
          this.modalRef = this.modalService.show(template, { class: 'modal-lg' });
        }

      }
    )
  }
removeHome()
{
  this.bannerSlider.sliderFor = "";

}

}



// WEBPACK FOOTER //
// ./src/app/BannerSlider/create-BannerSlider/create-BannerSlider.component.ts